import { render, staticRenderFns } from "./ExternalBI.vue?vue&type=template&id=5d35283e"
import script from "./ExternalBI.vue?vue&type=script&lang=js"
export * from "./ExternalBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports